import WishListCard from "./component/wishListCard";
import WishlistTabs from "./component/wishlistTabs";
import { useApplicationWishList } from "hooks/useWishList";
import NoData from "components/noData/noData";
import { useQueryClient } from "react-query";
import { useMount } from "react-use";
import { Spinner } from "react-bootstrap";
import ErrorMessage from "components/error/error";
import { useAuthContext } from "store/auth";

const WishlistApplications = () => {
	const [{user}]  = useAuthContext();
	const customerId = user.Id;;
	const { appsWishList, isLoading, isFetching, isSuccess,isError } =
		useApplicationWishList(customerId);
	const queryClient = useQueryClient();

	useMount(() => {
		queryClient.invalidateQueries(["apps-wishList"]);
	});

	return (
		<div className="wishlist app">
			<WishlistTabs />
			<div className="row">
			{isError && <ErrorMessage />}
				{(isLoading || isFetching) && (
					<div className="my-center">
						<Spinner animation="grow" variant="primary" />
					</div>
				)}
				{isSuccess && appsWishList.length > 0 ? (
					appsWishList.map(({ application, id, applicationId }) => (
						<div
							className="col-xl-2 col-lg-3 col-md-4 col-sm-6"
							key={id}
						>
							<WishListCard
								id={id}
								application
								itemId={applicationId}
								title={application.name}
								Label={application.label}
								logo={application.logo.fullPath}
								info={application.title}
								content={application.shortDescription}
								price={application.price}
								rate={application.rate}
							/>
						</div>
					))
				) : ( isSuccess || appsWishList.length < 0) &&	<NoData  packages={"wishlist"} />}
			</div>
		</div>
	);
};

export default WishlistApplications;
